import React from 'react';
import { connect } from 'react-redux';
import commonAction from '../../actions/common'
import Lodding from '../../components/Lodding'
import NoData from '../../components/NoData'
import { getSalaryMonthDetail } from '../../api/Salary'
import {
  buildSalarySummaryItems,
  formatSalaryAmount,
  getSalaryAmountClassName,
  getSalaryStatusClassName
} from '../../libs/salary'
import './index.scss'

class SalaryMonthDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: null,
      animating: false
    }
  }

  componentDidMount() {
    const pathname = this.props.path;
    this.props.dispatch({ type: commonAction.setPathname, pathname })
    this.props.onRef(this);
    this.getSalaryMonthDetailFun()
  }

  getSalaryMonthDetailFun = async () => {
    this.setState({
      animating: true
    })
    const res = await getSalaryMonthDetail({
      settlementMonth: this.props.match.params.month
    })
    if (res.code === 200) {
      this.setState({
        detail: res.data
      })
    }
    this.setState({
      animating: false
    })
  }

  goItemDetail = (item) => {
    this.props.history.push({
      pathname: `/layout/salary/item-detail/${this.props.match.params.month}/${item.detailType}`
    });
  }

  getItemExtraText = (detailType, detail) => {
    if (detailType === 1) {
      return `维保电梯数 ${detail.maintenanceLiftCount || 0}`
    }
    if (detailType === 2) {
      return `维修电梯数 ${detail.repairLiftCount || 0} / 维修台量 ${detail.repairOrderCount || 0}`
    }
    if (detailType === 3) {
      return `指派任务次数 ${detail.assignTaskCount || 0}`
    }
    if (detailType === 4) {
      return `指派支出任务数 ${detail.assignExpenseTaskCount || 0}`
    }
    return ''
  }

  render() {
    const detail = this.state.detail
    const items = buildSalarySummaryItems(detail || {})

    return (
      <div className="salaryMonthDetailBox commonBodyBox">
        {detail ? (
          <div className="salaryMonthDetailBox-main">
            <div className="salaryMonthDetailBox-summary">
              <div className="salaryMonthDetailBox-summary-top">
                <div>
                  <h3>{detail.settlementMonth}</h3>
                  <p>工资项汇总</p>
                </div>
                <span className={`salaryMonthDetailBox-status ${getSalaryStatusClassName(detail.settlementStatus)}`}>
                  {detail.settlementStatusName}
                </span>
              </div>
              <div className="salaryMonthDetailBox-summary-total">
                <span>共计</span>
                <strong>{formatSalaryAmount(detail.totalAmount)}</strong>
              </div>
              {detail.payableInfo ? (
                <div className="salaryMonthDetailBox-payable">
                  <p>已生成应付单：{detail.payableInfo.payableNo}</p>
                  <span>{detail.payableInfo.billDate}</span>
                </div>
              ) : ''}
            </div>

            <div className="salaryMonthDetailBox-list">
              {items.map((item) => (
                <div className="salaryMonthDetailBox-item" key={item.detailType} onClick={() => this.goItemDetail(item)}>
                  <div className="salaryMonthDetailBox-item-left">
                    <h4>{item.label}</h4>
                    <p>{this.getItemExtraText(item.detailType, detail)}</p>
                  </div>
                  <div className="salaryMonthDetailBox-item-right">
                    <span className={getSalaryAmountClassName(item.detailType)}>{formatSalaryAmount(item.value)}</span>
                    <em>查看明细</em>
                  </div>
                </div>
              ))}

              <div className="salaryMonthDetailBox-item is-total">
                <div className="salaryMonthDetailBox-item-left">
                  <h4>共计</h4>
                </div>
                <div className="salaryMonthDetailBox-item-right">
                  <span>{formatSalaryAmount(detail.totalAmount)}</span>
                </div>
              </div>
            </div>
          </div>
        ) : <NoData />}
        <Lodding animating={this.state.animating} />
      </div>
    )
  }
}

export default connect()(SalaryMonthDetail);
